export const MY_STOCK = 'my stock'
export const MY_TEAM_STOCK = 'my team stock'
export const MY_PLANT_STOCK = 'my plant stock'
export const ALL_TYPE_OPTIONS = [MY_STOCK, MY_TEAM_STOCK, MY_PLANT_STOCK]
